import * as React from 'react'

import {
  TextReviewElement,
  RatingReviewElement,
} from '@thg-commerce/enterprise-network/src/generated/graphql'

import { ProductPageData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'

export const ProductReviewSchema = (props: { product: ProductPageData }) => {
  if (!props.product.reviews) {
    return null
  }

  const reviewTitle = 'Review title'
  const reviewSchema = {
    '@context': 'https://schema.org',
    '@id': props.product.sku.toString(),
    review: props.product.reviews.reviews?.reviews?.length
      ? props.product.reviews.reviews.reviews.map((reviewItem) => {
          const description = (reviewItem.elements.find(
            (element) => element.key === 'content',
          ) as TextReviewElement).value
          const ratingScore = (reviewItem.elements.find(
            (element) => element.key === 'score',
          ) as RatingReviewElement).score
          const bestRatingValue = (reviewItem.elements.find(
            (element) => element.key === 'score',
          ) as RatingReviewElement).maxScore

          return {
            description,
            '@type': 'Review',
            datePublished: reviewItem.posted,
            itemReviewed: {
              '@type': 'Thing',
              name: reviewTitle,
            },
            reviewRating: {
              '@type': 'Rating',
              worstRating: 0,
              bestRating: bestRatingValue,
              ratingValue: ratingScore,
            },
            author: {
              '@type': 'Person',
              name: reviewItem.authorName,
            },
          }
        })
      : [],
  }

  return (
    <script
      type="application/ld+json"
      data-testid="product-review-schema"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(reviewSchema),
      }}
    />
  )
}
